import { useNavigate, useLocation } from "react-router-dom";
import { CHAPTERS } from "@/veedu/data";
import { scrollToId } from "@/hooks/useLenis";

const ChapterRail = ({ active }) => {
  const navigate = useNavigate();
  const location = useLocation();
  // Check active chapter theme dynamically (cream/light vs dark)
  const isLightBg = CHAPTERS[active]?.theme === "light";

  const handleChapterClick = (id) => {
    if (location.pathname !== "/") {
      navigate(`/#${id}`);
      setTimeout(() => {
        scrollToId(id);
      }, 150);
    } else {
      scrollToId(id);
    }
  };

  return (
    <aside
      data-testid="chapter-rail"
      className="fixed left-5 top-1/2 z-[150] hidden -translate-y-1/2 flex-col gap-4 lg:flex"
    >
      {CHAPTERS.map((c, i) => {
        const isActive = i === active;
        const isPast = i < active;

        return (
          <button
            key={c.id}
            data-testid={`chapter-link-${c.id}`}
            onClick={() => handleChapterClick(c.id)}
            className="group flex items-center gap-2.5 text-left"
          >
            {/* Number */}
            <span
              className={`font-body text-[9.5px] tracking-[0.3em] transition-all duration-300 w-5 shrink-0 ${
                isActive
                  ? isLightBg
                    ? "text-[#C4572D] font-bold"
                    : "text-brass font-bold"
                  : isLightBg
                  ? "text-[#382218]/70 font-semibold group-hover:text-[#382218]"
                  : "text-cream/40 group-hover:text-cream/80"
              }`}
            >
              {c.num}
            </span>

            {/* Tick / line connector */}
            <span
              className={`shrink-0 h-px transition-all duration-300 ${
                isActive
                  ? isLightBg
                    ? "w-7 bg-[#C4572D]"
                    : "w-7 bg-brass"
                  : isLightBg
                  ? "w-3 bg-[#382218]/30 group-hover:bg-[#382218]/70 group-hover:w-5"
                  : "w-3 bg-cream/25 group-hover:bg-cream/60 group-hover:w-5"
              }`}
            />

            {/* Label — high contrast & clear on both light and dark backgrounds */}
            <span
              className={`font-body text-[9px] tracking-[0.2em] uppercase transition-all duration-300 max-w-[110px] break-words whitespace-normal leading-[1.3] ${
                isActive
                  ? isLightBg
                    ? "text-[#C4572D] font-bold opacity-100"
                    : "text-cream font-bold opacity-100"
                  : isLightBg
                  ? "text-[#382218]/75 font-semibold group-hover:text-[#382218]"
                  : "text-cream/50 font-medium group-hover:text-cream/90"
              }`}
            >
              {c.name}
            </span>
          </button>
        );
      })}
    </aside>
  );
};

export default ChapterRail;
